import { ValueOf } from '../utilities/types';

const relatedIndividualsRoles = {
  CEO: 'ceo',
  MEMBER: 'member',
  CHAIRMAN: 'chairman',
  AUDITOR: 'auditor',
  OTHER: 'other',
} as const;

export type RelatedIndividualsRoles = ValueOf<typeof relatedIndividualsRoles>;

export const relatedIndividualsRolesChoices = [
  { id: relatedIndividualsRoles.CEO, name: 'CEO' },
  { id: relatedIndividualsRoles.MEMBER, name: 'Board member' },
  { id: relatedIndividualsRoles.CHAIRMAN, name: 'Chairman of the board' },
  { id: relatedIndividualsRoles.AUDITOR, name: 'Auditor' },
  { id: relatedIndividualsRoles.OTHER, name: 'Other' },
];

export default relatedIndividualsRoles;
